module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"selected_period":"選択期間","compared_period":"比較期間","radar":"レーダーチャート","radarTooltip":"前期と今期でどちらがパフォーマンスが上だったのかを知りたい時に役立つレーダーチャートです。KPIは3つ以上選択してください。","radarTooltip2":" ","compare_period":"比較期間"}}')
  delete Component.options._Ctor
}
